import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

export const JOB_NOTE_SCHEMA = Object.freeze({
  CONTENT: null,
  LAST_UPDATED_DATE: null,
});
const RECORD = generateSchema(JOB_NOTE_SCHEMA);
const KEYS: any = generateKeys(JOB_NOTE_SCHEMA);

export class JobNote extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get content(): string {
    return this.get(KEYS.CONTENT);
  }

  get lastUpdatedDate(): string {
    return this.get(KEYS.LAST_UPDATED_DATE);
  }
}
